import React from "react";
import { Layout } from "../components/Layout";
import { useLanguage } from "../context/LanguageContext";
import { siteContent } from "../mock/rosablu.mock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Card } from "../components/ui/card";

export default function FAQPage() {
  const { lang } = useLanguage();
  const faq = siteContent.faq[lang];
  const reviews = siteContent.reviews[lang];

  const ratingBadges = [
    {
      id: "airbnb",
      label: "Airbnb",
      value: "4,93/5",
    },
    {
      id: "airbnb-reviews",
      label: lang === "it" ? "15 recensioni" : "15 reviews",
      value: lang === "it" ? "Amato dagli ospiti" : "Guest favorite",
    },
    {
      id: "airbnb-top",
      label: lang === "it" ? "Top 10%" : "Top 10%",
      value: lang === "it" ? "Miglior alloggi" : "Best listings",
    },
  ];

  return (
    <Layout>
      <section className="bg-white pattern-faq py-14 md:py-18">
        <div className="mx-auto max-w-5xl px-4 md:px-6">
          <h1 className="font-serif text-2xl text-slate-900 md:text-3xl">
            {lang === "it" ? "Recensioni & domande frequenti" : "Reviews & FAQs"}
          </h1>

          {/* piccoli riferimenti alle piattaforme di recensione */}
          <div className="mt-3 flex flex-wrap gap-2 text-[0.7rem] text-slate-600">
            {ratingBadges.map((badge) => (
              <span
                key={badge.id}
                className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-3 py-1"
              >
                <span className="font-semibold">{badge.label}</span>
                <span className="text-slate-500">{badge.value}</span>
              </span>
            ))}
          </div>

          {/* RECENSIONI */}
          <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {reviews.map((rev) => (
              <Card
                key={rev.id}
                className="flex h-full flex-col rounded-3xl border-slate-100 bg-[#f8f1e8]/80 p-4 text-sm text-slate-800 shadow-sm"
              >
                <p className="text-sm leading-relaxed text-slate-800">“{rev.text}”</p>
                <div className="mt-3 text-xs text-slate-600">
                  <p className="font-semibold">{rev.name}</p>
                  <p className="mt-0.5 text-[0.7rem] uppercase tracking-[0.18em] text-slate-500">
                    {rev.tag}
                  </p>
                </div>
              </Card>
            ))}
          </div>

          {/* FAQ */}
          <div className="mt-10 rounded-3xl border border-slate-100 bg-[#f8f1e8]/80 p-4 shadow-sm backdrop-blur-md md:p-6">
            <h2 className="mb-4 font-serif text-xl text-slate-900 md:text-2xl">
              {faq.title}
            </h2>
            <Accordion type="single" collapsible className="w-full">
              {faq.items.map((item) => (
                <AccordionItem key={item.id} value={item.id} className="border-b border-slate-100 last:border-0">
                  <AccordionTrigger className="text-left text-sm font-medium text-slate-800">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-slate-700">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </Layout>
  );
}
